import { Flex, Text } from "@chakra-ui/react";
import { useParams } from "next/navigation";

import MoreNewsItem from "./MoreNewsItem";

const MoreFrom = ({ techNews, oneNews }) => {
  const params = useParams();
  const news = techNews?.filter((item) => item?.slug !== params?.news);

  return (
    <Flex
      flexDir={"column"}
      display={{ base: "flex", lg: "none" }}
      w={"100%"}
      maxW={"327px"}
      rowGap={"24px"}
    >
      <Text fontSize={"24px"} fontWeight={"700"} lineHeight={"normal"}>
        More from {oneNews?.source}:
      </Text>
      <Flex flexDir={"column"}>
        {news?.slice(0, 3)?.map((news) => (
          <MoreNewsItem key={news?.id} {...{ news }} />
        ))}
      </Flex>
    </Flex>
  );
};

export default MoreFrom;
